import { Injectable } from '@angular/core';
import { Effect, ofType, Actions } from '@ngrx/effects';
import { RoutingActionType, RoutingAction } from '../actions/routing.action';
import { tap } from 'rxjs/operators';
import { RoutesUtilsService } from '@vfde-fe/ngx-lib/services/routes-utils';
/** RoutingEffect */
@Injectable()
export class RoutingEffect {
    /** Effect */
    @Effect({dispatch: false})
    /** routingstart */
    public routingStart = this.actions.pipe(ofType<RoutingAction>(RoutingActionType.START_ROUTING), tap(
        ac => {
            this.routesUtilsService.navigateToURL(ac.payload.url, ac.payload.replaceUrl, ac.payload.targetUrl);
        },
    ));
    /**
     *
     * @param actions
     * @param routesUtilsService
     */
    public constructor (public actions: Actions, private routesUtilsService: RoutesUtilsService) { }
}
